import { httpClient } from "@coworker/http-client";
import { useQueries, useQuery } from "@tanstack/react-query";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { ImageSize } from "../enums/imageSizes";
import { ImageDetails } from "../types/ImageDetailsType";
import { ImageSignedUrlType } from "@coworker/apprestructured/src/tasks/types/imageSignedUrlType";

async function fetchSignedUrl(
  filename: string,
  size: ImageSize = ImageSize.LARGE
) {
  const result = await httpClient.tasks.get<ImageSignedUrlType>(
    "/v1/storage/get_signed_urls",
    { params: { size, filenames: filename } }
  );
  return result?.urls;
}

export function useGetImageSignedUrl(filename: string, size: ImageSize) {
  return useQuery({
    queryKey: ["image", "url", filename, size],
    queryFn: async () => await fetchSignedUrl(filename, size),
    staleTime: INTERVAL.DAY,
    enabled: !!filename && !!size,
  });
}

export function useGetImagesSignedUrls(
  taskImagesDetails: ImageDetails[] | undefined
) {
  return useQueries({
    queries:
      taskImagesDetails?.map((taskImage) => {
        return {
          queryKey: ["image", "url", taskImage.file_name, ImageSize.LARGE],
          queryFn: () => fetchSignedUrl(taskImage.file_name),
          enabled: !!taskImage.file_name,
          staleTime: INTERVAL.DAY,
        };
      }) ?? [],
  });
}
